import { render, staticRenderFns } from "./View_edit_client_report.vue?vue&type=template&id=b6c761dc"
import script from "./View_edit_client_report.vue?vue&type=script&lang=js"
export * from "./View_edit_client_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports